import React from 'react'
import {Grid, Text, useMultiStyleConfig} from '@chakra-ui/react'
import {FormattedMessage} from 'react-intl'
import PropTypes from 'prop-types'

const TicketCard = ({ticket}) => {
    const styles = useMultiStyleConfig('RepairTrackingTool')

    return (
        <Grid {...styles.ticketCardGrid}>
            <Text gridArea="ticket" {...styles.ticketCardHeader}>
                <FormattedMessage id="repair_tool.label.ticket" defaultMessage="Ticket:" />
            </Text>
            <Text gridArea="entryDate" {...styles.ticketCardHeader}>
                <FormattedMessage id="repair_tool.label.entry_date" defaultMessage="Entry Date:" />
            </Text>
            <Text gridArea="product" {...styles.ticketCardHeader}>
                <FormattedMessage id="repair_tool.label.product" defaultMessage="Product:" />
            </Text>
            <Text gridArea="repairShippingDate" {...styles.ticketCardHeader}>
                <FormattedMessage
                    id="repair_tool.label.shipping_date"
                    defaultMessage="Repair Shipping Date:"
                />
            </Text>
            <Text gridArea="status" {...styles.ticketCardHeader}>
                <FormattedMessage id="repair_tool.label.status" defaultMessage="Status:" />
            </Text>

            {/* Colonna destra (valori) */}
            <Text gridArea="Ticket" {...styles.ticketCardData}>
                {ticket.claimId}
            </Text>
            <Text gridArea="EntryDate" {...styles.ticketCardData}>
                {ticket.entryDate}
            </Text>
            <Text gridArea="Product" {...styles.ticketCardData}>
                {ticket.productDescription} ({ticket.sku})
            </Text>
            <Text gridArea="RepairShippingDate" {...styles.ticketCardData}>
                {ticket.exitDate}
            </Text>
            <Text
                gridArea="Status"
                fontWeight="bold"
                color={ticket.status.toUpperCase() === 'DELIVERED' ? 'green.600' : 'red.500'}
                {...styles.ticketCardData}
            >
                {ticket.status.toUpperCase()}
            </Text>
        </Grid>
    )
}

TicketCard.propTypes = {
    ticket: PropTypes.object.isRequired,
}

export default TicketCard
